// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"c7ec79fc","926":"f4a9602f"}[chunkId] + ".chunk.js";
};